export const getDiscountedPrice = ({ price, discount = {} }) => {
  const { number, isPercent } = discount
  if (Number(number) > 0) {
    // Percentage
    if (isPercent) {
      return (100 - number) / 100 * price
    }
    // Direct discount
    return price - number * 100
  }
  // No discount
  return false
}

export const convertFromCents = number => {
  let num = Number.parseFloat(number)
  if (Number.isNaN(num)) {
    num = 0
  }
  return (num / 100).toFixed(2)
}

export const isNotEmpty = number => {
  if (Number.parseFloat(number) !== 0 && !number) {
    return false
  }
  return true
}

export const createFromString = ({ name, email }) => `"${name}" <${email}>`

export const updateItemTotal = ({
  updateData,
  index,
  priceColumn,
  quantity,
}) => {
  let discountedPrice = getDiscountedPrice(priceColumn)
  if (discountedPrice === false) {
    discountedPrice = priceColumn.price
  }
  const total = discountedPrice * parseInt(quantity, 10)
  updateData(index, 'total', total > 0 ? total : 0)
}

export const getItemTotal = ({ priceColumn, quantity }) => {
  let discountedPrice = getDiscountedPrice(priceColumn)
  if (discountedPrice === false) {
    discountedPrice = priceColumn.price
  }
  const total = discountedPrice * parseInt(quantity, 10)
  return total > 0 ? total : 0
}
